import React, { useCallback, useContext, useEffect } from 'react';
import { Context } from '../../../../context/Context';
import { DesktopMenuContainer, DesktopMenuWrapper } from '../../SubPageNavigationStyles';
import { SUBMENUID } from '../../../../ContentType';
import { PagesMenu } from '../../ui/PagesMenu';

const DesktopMenu: React.FC = () => {
  const {
    stickymode,
    hasCta,
    content: { links },
    submenuDesktopRef,
    showSubmenu,
    toggleShowSubmenu,
  } = useContext(Context);

  const handleScroll = useCallback(() => {
    if (showSubmenu && window.innerWidth >= 1024) {
      toggleShowSubmenu();
    }
  }, [showSubmenu]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <DesktopMenuContainer isSticky={stickymode}>
      <DesktopMenuWrapper
        withCTA={hasCta}
        ref={submenuDesktopRef}
        className={showSubmenu && links.length > 0 ? 'show' : undefined}
        id={SUBMENUID.DESKTOP}
      >
        <PagesMenu />
      </DesktopMenuWrapper>
    </DesktopMenuContainer>
  );
};

export default DesktopMenu;
